module.exports = __webpack_public_path__ + "img/base3.2b1b4bd2.png";